"use client";

import React from "react";
import FreeAppraisal from "@/components/Common/FreeAppraisal";
import Hero from "@/components/Common/Hero";
import { createClient } from "../../../../prismicio";
import { SliceZone } from "@prismicio/react";
import Metadata from "@/components/Metadata";
import FAQ from "@/components/Common/FAQ";
import Layout from "@/components/Layout";
import Breadcrumbs from "@/components/Common/Breadcrumbs";
import FeatureDetailsSlice from "@/components/FeaturesDetails/FeatureDetails";

const BagsBuyers = ({ page, globals }) => {
  const pageData = page?.data;
  const commonComponents = globals?.data;

  const components = {
    faqs: FAQ,
  };

  const whyChooseUs = {
    features_details: FeatureDetailsSlice,
  };

  const whatWeBuy = {
    features_details: FeatureDetailsSlice,
  };

  const bestTime = {
    features_details: FeatureDetailsSlice,
  };

  return (
    <Layout data={commonComponents}>
      <Metadata
        title={pageData?.metadata_title}
        description={pageData?.metadata_desc}
        image={pageData?.metadata_image?.url}
        path="/what-we-buy/sell-diamonds-nyc"
      />
      <Hero
        caption={pageData?.hero_caption || ""}
        title={pageData?.hero_title || ""}
        sideImage={pageData?.hero_side_image.url || ""}
        sideImageMobile={pageData?.hero_mobile_side_image.url || ""}
        backgroundImage={pageData?.hero_background_image}
        description={pageData?.hero_description || ""}
        features={pageData?.hero_feature_list || []}
        page={"Sell Diamonds"}
        visibility={true}
        viewMoreLink="/what-we-buy/watch-buyers-nyc"
      />
      <Breadcrumbs />
      <SliceZone slices={page?.data?.slices4} components={bestTime} />
      <SliceZone slices={page?.data?.slices5} components={whatWeBuy} />
      <SliceZone slices={page?.data?.slices6} components={whatWeBuy} />
      <SliceZone slices={page?.data?.slices7} components={whatWeBuy} />
      <SliceZone slices={page?.data?.slices2} components={components} />
      <FreeAppraisal whiteBg={true} data={pageData} page={"Sell Diamonds"} />
    </Layout>
  );
};

export default BagsBuyers;

export async function getStaticProps({ previewData }) {
  const client = createClient({ previewData });

  const page = await client.getSingle("engagement_ring_buyers_page");
  const globals = await client.getSingle("globals");

  return {
    props: {
      page,
      globals,
    },
  };
}
